import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const Container = styled.div`
  position: relative;
`;
export const MenuContainer = styled.ul`
  overflow-y: auto;
  height: auto;
  overflow: hidden;
  width: 100%;
  padding:0;
  margin:8px 0;
  list-style:none;
  li {
    cursor: pointer;
    background-color: ${Variables.colors.complementary};
    height: 32px;
    a {
      width: 100%;
      padding: 8px 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.medium};
      line-height: 1.62;
      text-decoration: none;
      .link-external-icon {
        display: none;
        &:before {
          margin: 0 !important;
          font-size: 16px;
          color: ${Variables.colors.complementary_500};
        }
      }
    }
    &:hover {
      background-color: ${Variables.colors.complementary_200};
      .link-external-icon {
        display: block;
      }
    }
  }
`;
